import styled from 'styled-components';
import {
  boxShadow, primaryHeadingColor, wLight, secondaryFont, maxWidth, retina, maxTablet,
} from 'Utils/utilsStyle';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';

const Wrapper = styled.div`
  background-color: #fff;
  box-shadow: ${boxShadow};
  border-radius: 16px;
  padding: 23px;
  margin: 70px 0px;
  position: relative;
  z-index: 0;
  h4.recommended-name{
    color:${primaryHeadingColor};
    font-weight:${wLight};
    font-family:${secondaryFont};
    margin-bottom:0;
    font-size:22px;
    line-height: 38px;
    @media all and (max-width: ${maxWidth}) , ${retina} { 
     font-size: 18px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 14px;
      line-height: 19px;
    }
  }
  .user-images{
    position: relative;
    margin-right:13px;
    z-index:0;
    > div{
        padding:2px !important;
        &:nth-child(1){
          z-index:5;
        }
        &:nth-child(2){
          z-index:4;
          margin-left: -10px;
        }
        &:nth-child(3){
          z-index:3;
          margin-left: -10px;
        }
        &:nth-child(4){
          z-index:2;
          margin-left: -10px;
        }
        &:nth-child(5){
          z-index:1;
          margin-left: -10px;
        }
    }
  }
  .recommended-list{
    margin: 0px;
    padding-top: 30px;
  }
  .recommeded-hide{
    overflow:hidden;
    height:0px !important;
    margin:0;
    opacity:0 !important;
    padding-top: 0px !important;
  }
  .animate-height{
    height:auto;
    opacity:1;
    transition-duration: 1s;
  }
  .ant-collapse-content {
    transition: 0.5s ease all;
  }
  .ant-collapse-header, .ant-collapse-content-box {
    padding: 0px !important;
    align-items: center;
  }
  .ant-collapse-header {
    z-index: 1;
  }
  .heading-icon {
    display: block;
    margin-right: 15px;
    margin-top: 5px;
  }
  .ant-collapse-item {
    .ant-collapse-arrow {
      display: none !important;
    }
    .heading-collapse-c {
      .heading-icon {
        display: none;
      }
    }
    &.ant-collapse-item-active {
      .user-images {
        display: none;
      }
      .heading-collapse-c {
       
      }
      .ant-collapse-extra {
        display: none;
      }
    }
  }
  .un-collapse-btn {
    position: absolute;
    right: 23px;
    top: 21px;
    z-index: 2;
    @media all and (max-width: ${maxWidth}),${retina} {
      top: 28px;
    }
  }
  .body-collapse {
    &.one-line-persons {
      .ant-col {
        &:nth-last-child(1) {
          @media all and (max-width: 1440px){
            display: none !important;
          }
        }
      }
    }
  } 
  .header-collapse, .body-collapse {
    overflow: hidden;
    &.h-0 {
      height: 0px;
      transition: 0.5s ease all;
    }
    &.h-auto {
      height: auto;
      transition: 0.5s ease all;
    }
  }
`;

const SeeRecommendedSkeleton = function SeeRecommendedSkeleton() {
  return (
    <Wrapper>
      <div className="header-collapse minimize">
        <div className="d-flex heading-collapse-c">
          <div className="d-flex align-items-center user-images">
            {[1, 2, 3, 4, 5].map(() => <SkeletonCustom width="40px" height="40px" diameter="50%" margin="0px" />)}
          </div>

          <h4
            className="recommended-name d-flex align-items-center c-pointer"
          >
            <SkeletonCustom width="500px" height="20px" margin="0px" />
          </h4>
        </div>

      </div>
    </Wrapper>
  );
};

export default SeeRecommendedSkeleton;
